<template>
  <Breadcrumbs
      title="Module & Route Configurations"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Module & Route Configurations', path: '/module-route-configurations' },
    ]"
  />

  <div class="col-sm-12">
    <div class="card">
      <div class="card-body pb-3">
        <div class="page-grid mb-3">
          <div class="page-search-container">
            <input
                type="text"
                placeholder="Search modules..."
                class="search-input"
                v-model="searchQuery"
            />
          </div>
          <button type="button" class="btn button-default text-nowrap" @click="addNewModule">
            Add New Module
          </button>
        </div>

        <!-- Loading Indicator -->
        <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center py-5">
          <div class="spinner-border" style="color: #003366; width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3 text-muted" style="font-size: 1rem;">Fetching modules...</p>
        </div>

        <template v-else>
          <div class="table-responsive" v-if="filteredModules.length > 0">
            <table class="table table-hover table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Module Name</th>
                  <th class="text-center">No of Submodules</th>
                  <th class="text-center">No of Routes</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="module in filteredModules" :key="module.module_id">
                  <td class="align-middle"><strong>{{ module.module_name }}</strong></td>
                  <td class="align-middle text-center">
                    <span class="badge bg-secondary text-white">{{ module.submodule_count }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span class="badge bg-dark text-white" style="background-color: black !important;">{{ module.route_count }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span class="badge px-3 py-2" :style="{ backgroundColor: module.is_active ? '#198754' : '#dc3545', color: '#fff', borderRadius: '12px' }">
                      {{ module.is_active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td class="align-middle text-center">
                    <i class="fa fa-eye text-primary me-3 cursor-pointer" @click="viewModule(module.module_id)" title="View Module" style="font-size: 16px;"></i>
                    <i class="fa fa-edit text-secondary cursor-pointer" @click="editModule(module.module_id)" title="Edit Module" style="font-size: 16px;"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div v-else class="text-center p-4">
            <p class="text-muted">No modules found matching your search.</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getModuleSummary } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set'), //Get the API access token from the local storage
      searchQuery: '',
      loading: false,
      modulesData: []
    };
  },
  mounted() {
    this.fetchModulesList();
  },
  computed: {
    filteredModules() {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) {
        return this.modulesData;
      }
      return this.modulesData.filter(module =>
        module.module_name.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    async fetchModulesList() {
      const toast = useToast();
      // Set status loading
      this.loading = true;

      // Reset the module list
      this.modulesData = [];

      try {
        // Call Modules API to fetch data
        const response = await getModuleSummary(this.token);

        // API Response Visualization
        if(response.data.status === true) {
          this.modulesData = response.data.data;
        } else {
          toast.error(response.data.message || "Failed to retrieve modules");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "An error occurred while fetching modules.");
      } finally {
        this.loading = false;
      }
    },

    viewModule(id) {
      this.$router.push('/view-module/' + id);
    },
    addNewModule() {
      this.$router.push('/create-module');
    },
    editModule(id) {
      this.$router.push('/edit-module/' + id);
    }
  }
}
</script>

<style scoped>
.table-hover tbody tr:hover td {
  background-color: #f1f5f9 !important;
}
.page-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 15px;
}
.page-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.page-search-container {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.page-search-container.dropdown-item {
  flex-grow: 0;
  flex-basis: auto;
}
.search-input {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  width: 100%;
  min-width: 250px;
}
.search-input:hover {
  border-color: #0056b3;
}
.cursor-pointer {
  cursor: pointer;
}
.fa-edit:hover {
  color: #0056b3 !important;
  transform: scale(1.1);
}
@media (max-width: 768px) {
  .page-grid {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .page-search-container {
    width: 100%;
  }
  .search-input {
    min-width: 100%;
  }
}
</style>